// Argus — frontend lib pentru notifications.

import { apiFetch } from './api';

export type NotificationSeverity = 'info' | 'warning' | 'error' | 'success';

export interface Notification {
  readonly id: string;
  readonly severity: NotificationSeverity;
  readonly eventType: string;
  readonly title: string;
  readonly message: string;
  readonly payload: Record<string, unknown> | null;
  readonly createdAt: string;
  readonly readAt: string | null;
}

export interface NotificationsResponse {
  readonly items: readonly Notification[];
  readonly unreadCount: number;
}

export async function fetchNotifications(unreadOnly = false, limit = 50): Promise<NotificationsResponse> {
  const qs = new URLSearchParams();
  if (unreadOnly) qs.set('unread_only', '1');
  qs.set('limit', String(limit));
  const result = await apiFetch<NotificationsResponse>(`/api/v1/notifications?${qs.toString()}`);
  return result.data;
}

export async function markNotificationRead(id: string): Promise<void> {
  await apiFetch(`/api/v1/notifications/${id}/mark-read`, { method: 'POST' });
}

export async function markAllNotificationsRead(): Promise<void> {
  await apiFetch('/api/v1/notifications/mark-all-read', { method: 'POST' });
}
